export default {
    // aircraft: require('../images/aircraft.png'),
    // marker_pinlet: require('../images/marker-pinlet.png'),
    location_marker: require('../images/location_marker.png'),

    site_1: require('../images/icon-site-1.png'),
    site_2: require('../images/icon-site-2.png'),
    site_3: require('../images/icon-site-3.png'),
    site_4: require('../images/icon-site-4.png'),
    bg_site_2: require('../images/icon-bg-site-2.png'),
    bg_site_3: require('../images/icon-bg-site-3.png'),
    bg_site_4: require('../images/icon-bg-site-4.png'),

};
